import type {
	TailoredOnboardingM2P5TailoredTeamType,
	TailoredOnboardingTailoredTeamType,
} from './TailoredOnboardingTailoredTeamType.types.tsx';
import { tailoredM2P5TeamTypes, tailoredTeamTypes } from './tailoredTeamTypes.constants.tsx';

export const isTailoredOnboardingTeamType = (
	teamType: string,
): teamType is TailoredOnboardingTailoredTeamType => {
	// oxlint-disable-next-line typescript/consistent-type-assertions
	return tailoredTeamTypes.includes(teamType as TailoredOnboardingTailoredTeamType);
};

export const isTailoredOnboardingM2P5TailoredTeamType = (
	teamType: string,
): teamType is TailoredOnboardingM2P5TailoredTeamType => {
	// oxlint-disable-next-line typescript/consistent-type-assertions
	return tailoredM2P5TeamTypes.includes(teamType as TailoredOnboardingM2P5TailoredTeamType);
};
